import './backtest-parameters-form.scss';
import { reactInputStyles, selectSx } from '../../../../models/form-styles/styles';
import { SportsCategories } from '../../../../models/enums/sports-categories';
import { useState } from 'react';
import { StakingStrategies } from '../../../../models/enums/staking-strategies';
import { Bookmakers } from '../../../../models/enums/bookmakers';
import { TeamBetTypes } from '../../../../models/enums/team-bet-types';
import { PlayerBetTypes } from '../../../../models/enums/player-bet-types';
import { NbaTeams } from '../../../../constants/nba';
import { getNbaPlayersByTeamAndSeason } from '../../../../services/nba/services';
import { NbaOddsHistorical } from '../../../../models/odds/odds-historical';
import { GetNbaPlayersByTeamAndSeasonResponse, Player } from '../../../../models/services/get-nba-players-by-team-and-season-response';
import { AxiosResponse } from 'axios';
import { BacktestFeatureMapRequest } from '../../../../models/services/get-backtest-feature-map-request';
import { getFeatureMapForBacktest } from '../../../../services/backtest/services';
import { BacktestFeatureMapResponse } from '../../../../models/services/get-backtest-feature-map-response';
import { Market } from '../../../../models/odds/odds';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';

// TODO finish this and clean it up
const BacktestParametersForm = () => {
    const [sportsCategory, setSportsCategory] = useState(null as unknown as SportsCategories);
    const [season, setSeason] = useState(null);
    const [betType, setBetType] = useState(null as unknown as TeamBetTypes | PlayerBetTypes);
    const [stakingStrategy, setStakingStrategy] = useState(null); 
    const [oddsSource, setOddsSource] = useState(null);
    const [isPlayerBetType, setIsPlayerBetType] = useState(false);
    const [teamOptions, setTeamOptions] = useState([] as any);
    const [playerOptions, setPlayerOptions] = useState([] as any);
    const [team, setTeam] = useState(null);
    const [player, setPlayer] = useState(null as unknown as {
        value: number; label: string; 
    });
    
    /** select options **************************************************************/
    /********************************************************************************/
    const getMenuItemsFromEnum = (e: any, addNone?: boolean) => {
        const items =  Object.values(e).map((enumVal: any) => {
            return <MenuItem value={enumVal}>{enumVal}</MenuItem>;
        });
        
        return addNone ? items.concat([
            <MenuItem value="">
                <em>None</em>
            </MenuItem>
        ]) : items;
    }

    const getMenuItemsFromStrings = (strs: any, addNone?: boolean) => {
        const items = strs.map((str: any) => {
            return <MenuItem value={str}>{str}</MenuItem>;
        });
        
        return addNone ? items.concat([
            <MenuItem value="">
                <em>None</em>
            </MenuItem>
        ]) : items;
    }
    const sportsCategoriesOptions: any[] = getMenuItemsFromEnum(SportsCategories, true);
    
    const seasonOptions: any[] = getMenuItemsFromStrings(['2023'], true);
    
    const betTypeOptions: any[] = getMenuItemsFromEnum(TeamBetTypes)
        .concat(getMenuItemsFromEnum(PlayerBetTypes, true));
    
    const stakingStrategyOptions = getMenuItemsFromEnum(StakingStrategies, true);

    const oddsSourceOptions = getMenuItemsFromEnum(Bookmakers, true);
    
    const loadTeamOptions = (_season: any, sport: SportsCategories) => {
        switch(sport) {
            case SportsCategories.NBA: {
                const options = NbaTeams.map(x => { 
                    return { value: x.teamNickname, label: x.teamNickname }
                });
                setTeamOptions(options);
                break;
            }
            default: setTeamOptions([] as any); break;
        }
    };

    const loadPlayerOptions = (season: any, sport: SportsCategories) => {
        switch(sport) {
            case SportsCategories.NBA: {
                const teamId = NbaTeams.find((currTeam: any) => currTeam.teamNickname === team)!.nbaApiId!;
                getNbaPlayersByTeamAndSeason({ teamId: teamId, season: season })
                    .then((response: AxiosResponse<GetNbaPlayersByTeamAndSeasonResponse>) => {
                        setPlayerOptions(
                            (response.data?.response || []).map((player: Player) => ({
                                label: `${player.firstname} ${player.lastname}`,
                                value: player.id
                            }))
                        );
                    })
                    .catch((error: any) => {
                        console.error("Error fetching NBA players: ", error);
                        setPlayerOptions([] as any);
                    });
                break;
            }
            default: setPlayerOptions([] as any); break;
        }
    }
    /********************************************************************************/

    /** on selection functions ******************************************************/
    /********************************************************************************/
    const onSportsCategorySelection = (sportsCategory: SportsCategories) => {
        setSportsCategory(sportsCategory);
        loadTeamOptions(season, sportsCategory);
    }

    const onSeasonSelection = (season: any) => {
        setSeason(season);
        loadTeamOptions(season, sportsCategory);
    }

    const handleBetTypeChange = (betType: any) => {
        setBetType(betType.target.value);
        if (new Set(Object.values(TeamBetTypes)).has(betType as TeamBetTypes)) {
            setIsPlayerBetType(false);
        } else {
            setIsPlayerBetType(true);
            loadPlayerOptions(season, sportsCategory);
        }
    }


    const handleSportsCategoryChange = (event: SelectChangeEvent) => {
        setSportsCategory(event.target.value as any);
    };

    const handleSeasonChange = (event: SelectChangeEvent) => {
        setSeason(event.target.value as any);
    };

    // const handleBetTypeChange = (event: SelectChangeEvent) => {
    //     setBetType(event.target.value as any);
    // };

    const handlePlayerChange = (event: SelectChangeEvent) => {
        setPlayer(event.target.value as any);
    };

    const handleStakingStrategyChange = (event: SelectChangeEvent) => {
        setStakingStrategy(event.target.value as any);
    };

    const handleOddsSourceChange = (event: SelectChangeEvent) => {
        setOddsSource(event.target.value as any);
    };
    /********************************************************************************/


    /** data aggregation functions **************************************************/
    /********************************************************************************/
    const parseOddsData = (
        historicalOddsData: any,
        betType: TeamBetTypes | PlayerBetTypes,
        bookmakers: Bookmakers
    ) => {
        let filteredOddsData; 
        if (sportsCategory === SportsCategories.NBA) {
            filteredOddsData = (historicalOddsData as NbaOddsHistorical[]).reduce(
                (oddsArr, currObj: NbaOddsHistorical) => {
                    const oddsForOddsSource = currObj.bookmakerOdds
                        .find((obj) => obj.title === oddsSource);
                    const oddsObj = oddsForOddsSource?.markets
                        .find(obj => obj.key === betType)

                    if (oddsObj) {
                        oddsArr.push(oddsObj);
                    }
                    return oddsArr;
                },
                [] as Market[]
            );
        }
        return filteredOddsData;
    }

    const aggregateData = async () => {
        let featureMap;
        switch(sportsCategory) {
            case (SportsCategories.NBA): {
                
                const teamId = NbaTeams.find((currTeam: any) => currTeam.teamNickname === team)?.nbaApiId!
                if (sportsCategory && season && teamId && betType && stakingStrategy && oddsSource) {
                    const getFeatureMapReq: BacktestFeatureMapRequest = {
                        sportsCategory: sportsCategory,
                        season: season,
                        teamId: teamId,
                        teamBetType: new Set(Object.values(TeamBetTypes)).has(betType as TeamBetTypes) ? betType as TeamBetTypes : undefined,
                        playerBetType: new Set(Object.values(PlayerBetTypes)).has(betType as PlayerBetTypes) ? betType as PlayerBetTypes : undefined,
                        stakingStrategy: stakingStrategy,
                        oddsSource: oddsSource,
                        bankRoll: 100 /* default */,
                        model: 'random model',
                        playerId: player?.value ? player.value : undefined
                    };

                    getFeatureMapForBacktest(getFeatureMapReq)
                        .then((resp: AxiosResponse<BacktestFeatureMapResponse>) => {
                            console.log('BACKTEST API RESPONSE: ', resp.data);
                        })
                        .catch((error: any) => console.error('ERROR OCCURRED', error));
                }
                break;
            }
            default: break;
        }
        return featureMap;
    }

    const getGamesFeatureMap = (historicalGameData: any): any => {
        return [];
    }

    const getOddsFeatureMap = (historicalOddsData: any): any => {
        return [];
    }

    const getPlayerStatsFeatureMap = (playerStatsAvgsData: any): any => {
        return [];
    }
    /********************************************************************************/

    /** action functions ************************************************************/
    /********************************************************************************/
    const runBacktest = ($event: any) => {
        $event.preventDefault();
        aggregateData();
    }

    
    const openAdvancedSettings = () => {
    };
    /********************************************************************************/

    
    /** html ************************************************************************/
    /********************************************************************************/
    return (
        <div className="backtest-parameters-form-container">
            <div className="backtest-parameters-form">
                <FormControl variant="standard" sx={{ minWidth: 145 }}>
                    <InputLabel id="demo-simple-select-label">Sports Category</InputLabel>
                    <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={''}
                        onChange={handleSportsCategoryChange}
                        sx={selectSx}
                    >
                        {sportsCategoriesOptions}
                    </Select>
                </FormControl>
                <FormControl variant="standard" sx={{ minWidth: 145 }}>
                    <InputLabel id="demo-simple-select-label">Season</InputLabel>
                    <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={''}
                        onChange={handleSeasonChange}
                        sx={selectSx}
                    >
                        {seasonOptions}
                    </Select>
                </FormControl>
                <FormControl variant="standard" sx={{ minWidth: 145 }}>
                    <InputLabel id="demo-simple-select-label">Bet Type</InputLabel>
                    <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={''}
                        onChange={handleBetTypeChange}
                        sx={selectSx}
                    >
                        {betTypeOptions}
                    </Select>
                </FormControl>
                <FormControl variant="standard" sx={{ minWidth: 145 }}>
                    <InputLabel id="demo-simple-select-label">Player</InputLabel>
                    <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={undefined}
                        onChange={handlePlayerChange}
                        sx={selectSx}
                    >
                    </Select>
                </FormControl>
                <FormControl variant="standard" sx={{ minWidth: 145 }}>
                    <InputLabel id="demo-simple-select-label">Staking Strategy</InputLabel>
                    <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={undefined}
                        onChange={handleStakingStrategyChange}
                        sx={selectSx}
                    >
                        {stakingStrategyOptions}
                    </Select>
                    </FormControl>
                <FormControl variant="standard" sx={{ minWidth: 145 }}>
                    <InputLabel id="demo-simple-select-label">Odds Source</InputLabel>
                    <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={undefined}
                        onChange={handleOddsSourceChange}
                        sx={selectSx}
                    >
                        {oddsSourceOptions}
                    </Select>
                </FormControl>
                {/* <FormControl variant="standard" sx={{ minWidth: 128 }}>
                    <InputLabel id="demo-simple-select-label">Bankroll USD</InputLabel>
                    <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={{}}
                        onChange={handleBankrollUSD}
                        sx={selectSx}
                    >
                    </Select>
                </FormControl> */}
            </div>
            {/* <form className="form-body">
                <div className="strategy-inputs">
                    <div className="select-container">
                        <label className="select-label">Sports Category</label>
                        <Select
                            classNamePrefix="select"
                            options={sportsCategoriesOptions}
                            value={ sportsCategory ? { value: sportsCategory, label: sportsCategory } : null }
                            onChange={(x: any) => onSportsCategorySelection(x.value)}
                            isClearable
                        />
                    </div>
                    <div className="select-container">
                        <label className="select-label">Season</label>
                        <Select
                            classNamePrefix="select"
                            options={seasonOptions}
                            value={ season ? { value: season, label: season } : null }
                            onChange={(x: any) => { if (x) onSeasonSelection(x.value) }}
                            isClearable
                        />
                    </div>
                    {
                        sportsCategory && season ? 
                        <div className="select-container">
                            <label className="select-label">Team</label>
                            <Select
                                classNamePrefix="select"
                                options={teamOptions}
                                value={team ? { value: team, label: team } : null}
                                onChange={(x: any) => { if (x ) setTeam(x.value) }}
                                isClearable
                            />
                        </div> : null
                    }
                    <div className="select-container">
                        <label className="select-label">Bet Type</label>
                        <Select
                            classNamePrefix="select"
                            options={betTypeOptions}
                            value={ betType ? { value: betType, label: betType } : null }
                            onChange={(x: any) => { if (x) onBetTypeSelection(x.value) }}
                            isClearable
                        />
                    </div>
                    {
                        isPlayerBetType && team ? 
                        <div className="select-container">
                            <label className="select-label">Player</label>
                            <Select
                                classNamePrefix="select"
                                options={playerOptions}
                                value={ player ? { value: player.value, label: player.label } : null }
                                onChange={(x: any) => { if (x) setPlayer(x) }}
                                isClearable
                            />
                        </div> : null
                    }
                    <div className="select-container">
                        <label className="select-label">Staking Strategy</label>
                        <Select
                            classNamePrefix="select"
                            options={stakingStrategyOptions}
                            value={ stakingStrategy ? { value: stakingStrategy, label: stakingStrategy } : null }
                            onChange={(x: any) => { if (x) setStakingStrategy(x.value) }}
                            isClearable
                        />
                    </div>
                    <div className="select-container">
                        <label className="select-label">Odds Source</label>
                        <Select
                            classNamePrefix="select"
                            options={oddsSourceOptions}
                            value={ oddsSource ? { value: oddsSource, label: oddsSource } : null }
                            onChange={(x: any) => { if (x) setOddsSource(x.value) }}
                            isClearable
                        />
                    </div>
                    <div className="input-container">
                        <label className="input-label">Bankroll USD</label>
                        <input placeholder='100' style={reactInputStyles as any}></input><span></span>
                    </div>
                    <div className="select-container">
                        <label className="select-label">Model</label>
                        <Select
                            classNamePrefix="select"
                            options={undefined}
                            value={() => {}}
                            onChange={() => {}}
                            isClearable
                        />
                    </div>
                </div>
                <button className="run-button" onClick={runBacktest}>
                        Run
                </button>
            </form> */}
            <div className="advanced-settings-div">
                <span className="text-button" onClick={openAdvancedSettings}>
                    Advanced Settings
                </span>
            </div>
        </div>
    );
    /********************************************************************************/
}

export default BacktestParametersForm;